import { useProjectStore } from "entity-store/project-store/use-project-store";
import {
  sizeInCMFromPreset,
  sizeInInchesFromPreset,
  PosterSizePreset,
} from "PosterEditor/model/poster-project";
import { useCheckoutPricing } from "./use-checkout-pricing";
import { useSizePresets } from "PosterEditor/model/size-presets/size-preset";
import { size } from "lodash";

interface ProjectFormatCheckout {
  title: string;
  id: string;
  sku: string;
  name: string;
  description: string;
  priceString: string;
  priceValue: number;
  productID: string;
}

export const useProjectFormatter = () => {
  const { loadProject } = useProjectStore();
  const { sizePresetByID } = useSizePresets();
  const { formattedPriceForProject, priceValueForProject } =
    useCheckoutPricing();

  const formatForCheckout = (
    projectID: string
  ): ProjectFormatCheckout | undefined => {
    const project = loadProject(projectID);
    if (!project) return undefined;

    const sizePresetID = project?.sizeOption.presetID;
    if (!sizePresetID) return undefined;

    const preset = sizePresetByID(sizePresetID);
    if (!preset) return undefined;

    const description = `${preset.sizeDescription} - ${preset.materialDescription}`;

    return {
      title: preset.materialDescription,
      id: project.id,
      sku: preset.sku,
      name: project.name || "",
      description: description,
      priceValue: priceValueForProject(project),
      priceString: formattedPriceForProject(project),
      productID: sizePresetID,
    };
  };

  return {
    formatForCheckout,
  };
};

const sizeString = (size: PosterSizePreset): string => {
  const cmSize = sizeInCMFromPreset(size);
  const inchSize = sizeInInchesFromPreset(size);
  const cm = `${cmSize.width} x ${cmSize.height} cm`;
  const inch = `${inchSize.width} x ${inchSize.height} in`;

  return `${cm} / (${inch})`;
};
